import axios from "axios";
import React, { useState, useEffect, useContext, useRef } from "react";
import { useAuth } from '../../../../context/AuthContext';
import { useNavigate, useParams } from "react-router-dom";
import RealMatch from "./QuestionTypes/RealMatch"
import VideoContent from "./QuestionTypes/VideoContent"
import Choice from "./QuestionTypes/Choice"
import Write from "./QuestionTypes/Write";
import Match from "./QuestionTypes/Match";
import TrueFalse from "./QuestionTypes/TrueFalse";
import Sentence from "./QuestionTypes/Sentence";
import Pagination from "./QuestionTypes/Pagination";
import Link from "./QuestionTypes/Link";
import { API_BASE_URL } from "../../../../Helpers/apiConfig";
import {
    CORRECT_SOUND_URL,
    FIRST_INCORRECT_SOUND_URL,
    LAST_INCORRECT_SOUND_URL,
    MATCH_SOUND_URL,
    CHOOICE_AND_SENTENCE_SOUND_URL,
    UNSCREAMBLE_SOUND_URL
} from "../../../../Helpers/effects";

import { LayoutContext } from "../../DashboardLayout";

export const UserQuestion = () => {
    const params = useParams();
    const { user } = useAuth();
    const [msg, setMsg] = useState([]);
    const [loading, setLoading] = useState(true);
    const [dataa, setDataa] = useState([]);
    const [questionType, setquestionType] = useState([]);
    const [questionCount, setquestionCount] = useState([]);
    const [questionNumber, setquestionNumber] = useState([]);
    const [truefalseanswercount, settruefalseanswercount] = useState([]);
    const [pagination, setPagination] = useState([]);
    const [answer, setAnswer] = useState([]);
    const [answered, setAnswered] = useState(false);
    const [realAnswer, setrealAnswer] = useState("");
    const [color, setColor] = useState("");
    const [subjectId, setSubjectId] = useState("");
    const [realAnswers, setRealAnswers] = useState([]);
    const [zoomLevel, setZoomLevel] = useState(1); // 1 = %100 orijinal boyut
    const [paginationAnswers, setpaginationAnswers] = useState([]);
    const { setContentStyle } = useContext(LayoutContext);

    const navigate = useNavigate();
    const successAudioRef = useRef(null);
    const errorAudioRef = useRef(null);
    const correctAudioRef = useRef(null);
    const firstIncorrectAudioRef = useRef(null);
    const lastIncorrectAudioRef = useRef(null);
    const matchAudioRef = useRef(null);
    const choiceSentenceAudioRef = useRef(null);
    const unscrambleAudioRef = useRef(null);

    const playSound = (ref) => () => {
        if (ref.current) {
            ref.current.currentTime = 0;
            ref.current.play().catch(() => { });
        }
    };

    const playSuccessSound = playSound(successAudioRef);
    const playErrorSound = playSound(errorAudioRef);
    const playCorrectSound = playSound(correctAudioRef);
    const playFirstIncorrectSound = playSound(firstIncorrectAudioRef);
    const playLastIncorrectSound = playSound(lastIncorrectAudioRef);
    const playMatchSound = playSound(matchAudioRef);
    const playChoiceSentenceSound = playSound(choiceSentenceAudioRef);
    const playUnscrambleSound = playSound(unscrambleAudioRef);

    // --- ZOOM KONTROL FONKSİYONLARI (%5 ARTIŞ / AZALIŞ) ---
    const handleZoomIn = () => {
        setZoomLevel(prev => Math.min(prev + 0.05, 1.5)); // Maksimum %150 sınır
    };

    const handleZoomOut = () => {
        setZoomLevel(prev => Math.max(prev - 0.05, 0.50)); // Minimum %50 sınır
    };
    // ----------------------------------

    useEffect(() => {
        successAudioRef.current = new Audio("https://api.heryerdeingilizce.com/sound/624c0620-d97e-46ba-8f03-3748bd1ed1af.mp4");
        errorAudioRef.current = new Audio("https://api.heryerdeingilizce.com/sound/ca04bbe0-aff6-45c3-8976-b9c6ea031dc8.mp4");
        correctAudioRef.current = new Audio(CORRECT_SOUND_URL);
        firstIncorrectAudioRef.current = new Audio(FIRST_INCORRECT_SOUND_URL);
        lastIncorrectAudioRef.current = new Audio(LAST_INCORRECT_SOUND_URL);
        matchAudioRef.current = new Audio(MATCH_SOUND_URL);
        choiceSentenceAudioRef.current = new Audio(CHOOICE_AND_SENTENCE_SOUND_URL);
        unscrambleAudioRef.current = new Audio(UNSCREAMBLE_SOUND_URL);

        [
            successAudioRef, errorAudioRef, correctAudioRef, firstIncorrectAudioRef,
            lastIncorrectAudioRef, matchAudioRef, choiceSentenceAudioRef, unscrambleAudioRef
        ].forEach((ref) => {
            ref.current.preload = "auto";
            ref.current.load();
        });
    }, []);

    useEffect(() => {
        const isMobile = window.innerWidth <= 768;

        if (isMobile) {
            document.body.style.overflow = "auto";
        }

        const handleContextMenu = (e) => e.preventDefault();
        document.addEventListener("contextmenu", handleContextMenu);

        return () => {
            document.removeEventListener("contextmenu", handleContextMenu);
        };
    }, []);

    // 1) SUBJECT ID GETİR
    useEffect(() => {
        const getSubjectId = async () => {
            try {
                const res = await axios.get(
                    `${API_BASE_URL}/user/Content/GetSubject`,
                    {
                        headers: { Authorization: "Bearer " + user.token },
                        params: { courseId: params.courseid }
                    }
                );
                if (res.data.success) {
                    const found = res.data.data.subjects.find(
                        (s) => Number(s.sortId) === Number(params.subjectid)
                    );
                    if (found) setSubjectId(found.id);
                }
            } catch (err) {
                console.log(err);
            }
        };

        getSubjectId();
    }, [params.subjectid]);

    // 2) SUBJECT ID GELİNCE RENK GETİR
    useEffect(() => {
        if (!subjectId) return;

        const getColor = async () => {
            try {
                const renkdata = await axios.get(
                    "https://express.heryerdeingilizce.com/getsubjectcolourbyid/" +
                    subjectId
                );
                setColor(renkdata.data[0].colourcode);
            } catch (err) {
                setMsg(err);
            }
        };

        getColor();
    }, [subjectId]);

    // 3) COLOR GELİNCE ARKAPLAN GÜNCELLE
    useEffect(() => {
        if (color) {
            setContentStyle({ backgroundColor: color });
        }
    }, [color]);

    const checkAnswered = (questionId) => {
        let found = null;

        realAnswers.forEach(course => {
            course.subjects.forEach(subject => {
                subject.answers.forEach(answerItem => {
                    if (Number(answerItem.questionId) === Number(questionId)) {
                        found = answerItem;
                    }
                });
            });
        });

        if (found) {
            setAnswered(true);
            setrealAnswer(found.isTrue ? "Doğru" : "Yanlış");
        } else {
            setAnswered(false);
            setrealAnswer("");
        }
    };

    const getAnswerInfo = (questionId) => {
        let found = null;

        realAnswers.forEach(course => {
            course.subjects.forEach(subject => {
                subject.answers.forEach(answerItem => {
                    if (Number(answerItem.questionId) === Number(questionId)) {
                        found = answerItem;
                    }
                });
            });
        });

        return {
            answered: !!found,
            answerCorrect: found ? !!found.isTrue : false
        };
    };

    useEffect(() => {
        setAnswered(false);
        const report = async () => {
            setLoading(true);
            try {
                const headerss = {
                    "accept": "*/*",
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Credentials': 'false',
                    'Authorization': 'Bearer ' + user.token
                }

                let url = `${API_BASE_URL}/user/Opt/MyReport`;
                await axios({
                    method: 'GET',
                    url: url,
                    headers: headerss
                }).then(res => {
                    if (res.status === 200) {
                        if (res.data['success']) {
                            setRealAnswers(res.data['data'] || []);
                        }
                        else {
                            setMsg(res.data['message']);
                        }
                    }
                    else {
                        setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                    }
                });
            }
            catch (err) {
                setMsg(err);
            }
            setLoading(false);
        }

        const fetchdata = async () => {
            setLoading(true);
            try {
                const headerss = {
                    "accept": "*/*",
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Credentials': 'false',
                    'Authorization': 'Bearer ' + user.token
                }

                let url = `${API_BASE_URL}/user/Content/GetContent`;
                await axios({
                    method: 'GET',
                    url: url,
                    params: {
                        courseId: params["courseid"],
                        sortId: params["subjectid"]
                    },
                    headers: headerss
                }).then(res => {
                    if (res.status === 200) {
                        if (res.data['success']) {
                            setquestionCount(res.data['data']['contents'].length);
                            if (Number(params["id"]) > res.data['data']['contents'].length) {
                                navigate("/user/course/subject/" + params["courseid"]);
                            }
                            else {

                                setquestionNumber(res.data['data']['contents'][Number(params['id']) - 1]['id']);
                                let realData = res.data['data']['contents'][Number(params['id']) - 1];
                                setDataa(realData);

                                let questionId = res.data['data']['contents'][Number(params['id']) - 1]['id'];

                                checkAnswered(questionId);

                                for (let a = 0; a < realAnswers.length; a++) {
                                    const course = realAnswers[a];
                                    course.subjects.forEach(subject => {
                                        subject.answers.forEach(answerItem => {
                                            if (Number(answerItem.questionId) === Number(questionId)) {
                                                setAnswered(true);
                                                setrealAnswer(answerItem.isTrue ? "Doğru" : "Yanlış");
                                            }
                                        });
                                    });
                                }

                                const tempPagination = [];

                                if (res.data['data']['contents'].length !== 0) {
                                    for (let i = 0; i < res.data['data']['contents'].length; i++) {

                                        let num = Number(i) + 1;
                                        let activity = false;

                                        if (Number(params['id'] - 1) === Number(i)) {
                                            activity = true;
                                        }

                                        const info = getAnswerInfo(res.data['data']['contents'][i]['id']);

                                        tempPagination.push(
                                            {
                                                "id": i + 1,
                                                "href": "/user/course/question/" + params['courseid'] + "/" + params['subjectid'] + "/" + num.toString(),
                                                "isActive": activity,
                                                "answered": info.answered,
                                                "answerCorrect": info.answerCorrect
                                            }
                                        )
                                    }
                                }

                                setPagination(tempPagination);
                                setquestionType(res.data['data']['contents'][Number(params['id']) - 1]['contentType']);
                                setAnswer(res.data['data']['contents'][Number(params['id']) - 1]['answer']);

                                let x = JSON.parse(realData['detail']);
                                settruefalseanswercount(x.length);
                            }

                        }
                        else {
                            setMsg(res.data['message']);
                        }
                    }
                    else {
                        alert("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                        setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                    }
                });
            }
            catch (err) {
                alert(err)
                setMsg(err);
            }
            setLoading(false);
        }

        const run = async () => {
            await report();
            await fetchdata();
        };

        run();
        const handleContextMenu = (e) => e.preventDefault();
        document.addEventListener("contextmenu", handleContextMenu);

        return () => {
            document.removeEventListener("contextmenu", handleContextMenu);
        };

    }, [params.id, params.subjectid, realAnswers.length]);

    // --- DİNAMİK SORU BİLEŞENİ SEÇİCİ ---
    const renderQuestionComponent = () => {
        if (questionType === 'video') {
            return <VideoContent data={dataa} questionCount={questionCount} />;
        } else if (questionType === 'write') {
            return <Write data={dataa} questionNumber={questionNumber} answer={answer} answered={answered} realanswer={realAnswer}
                playSuccessSound={playSuccessSound} playErrorSound={playErrorSound}
                playCorrectSound={playCorrectSound} playFirstIncorrectSound={playFirstIncorrectSound} playLastIncorrectSound={playLastIncorrectSound} />;
        } else if (questionType === 'choice') {
            return <Choice data={dataa} questionNumber={questionNumber} answer={answer} answered={answered} realanswer={realAnswer}
                playSuccessSound={playSuccessSound} playErrorSound={playErrorSound}
                playCorrectSound={playCorrectSound} playFirstIncorrectSound={playFirstIncorrectSound} playLastIncorrectSound={playLastIncorrectSound}
                playChoiceSentenceSound={playChoiceSentenceSound} />;
        } else if (questionType === 'match') {
            return <Match data={dataa} questionNumber={questionNumber} answer={answer} answered={answered} realanswer={realAnswer}
                playSuccessSound={playSuccessSound} playErrorSound={playErrorSound}
                playCorrectSound={playCorrectSound} playFirstIncorrectSound={playFirstIncorrectSound} playLastIncorrectSound={playLastIncorrectSound}
                playUnscrambleSound={playUnscrambleSound} />;
        } else if (questionType === 'truefalse') {
            return <TrueFalse data={dataa} truefalseanswercount={truefalseanswercount} questionNumber={questionNumber} answer={answer} answered={answered} realanswer={realAnswer}
                playSuccessSound={playSuccessSound} playErrorSound={playErrorSound}
                playCorrectSound={playCorrectSound} playFirstIncorrectSound={playFirstIncorrectSound} playLastIncorrectSound={playLastIncorrectSound} />;
        } else if (questionType === 'realmatch') {
            return <RealMatch data={dataa} questionNumber={questionNumber} answer={answer} answered={answered} realanswer={realAnswer}
                playSuccessSound={playSuccessSound} playErrorSound={playErrorSound}
                playCorrectSound={playCorrectSound} playFirstIncorrectSound={playFirstIncorrectSound} playLastIncorrectSound={playLastIncorrectSound}
                playMatchSound={playMatchSound} />;
        } else if (questionType === 'sentence') {
            return <Sentence data={dataa} questionNumber={questionNumber} answer={answer} answered={answered} realanswer={realAnswer}
                playSuccessSound={playSuccessSound} playErrorSound={playErrorSound}
                playCorrectSound={playCorrectSound} playFirstIncorrectSound={playFirstIncorrectSound} playLastIncorrectSound={playLastIncorrectSound}
                playChoiceSentenceSound={playChoiceSentenceSound} />;
        } else if (questionType === 'link') {
            return <Link data={dataa} questionNumber={questionNumber} answer={answer} answered={answered} realanswer={realAnswer} playSuccessSound={playSuccessSound} playErrorSound={playErrorSound} />;
        }
        return null;
    };

    if (loading) {
        return <div>Yükleniyor...</div>;
    }

    return (
        <div style={{ position: "relative", width: "100%", minHeight: "65vh", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>

            {/* Sağ Üst Sabit Zoom Paneli */}
            <div style={{
                position: "absolute",
                top: "5px",
                right: "10px",
                zIndex: 9999,
                display: "flex",
                alignItems: "center",
                gap: "6px",
                backgroundColor: "#ffffff",
                padding: "4px 8px",
                borderRadius: "8px",
                boxShadow: "0 2px 6px rgba(0,0,0,0.12)",
                border: "1px solid #e5e7eb"
            }}>
                <button
                    type="button"
                    onClick={handleZoomOut}
                    style={{
                        cursor: "pointer", border: "1px solid #cbd5e1", background: "#f8fafc",
                        width: "28px", height: "28px", borderRadius: "6px", fontSize: "16px",
                        display: "flex", alignItems: "center", justifyContent: "center", color: "#334155",
                        fontWeight: "bold"
                    }}
                >
                    -
                </button>
                <span style={{ fontSize: "13px", fontWeight: "bold", color: "#1e293b", minWidth: "38px", textAlign: "center" }}>
                    %{Math.round(zoomLevel * 100)}
                </span>
                <button
                    type="button"
                    onClick={handleZoomIn}
                    style={{
                        cursor: "pointer", border: "1px solid #cbd5e1", background: "#f8fafc",
                        width: "28px", height: "28px", borderRadius: "6px", fontSize: "16px",
                        display: "flex", alignItems: "center", justifyContent: "center", color: "#334155",
                        fontWeight: "bold"
                    }}
                >
                    +
                </button>
            </div>

            {/* YALNIZCA SORU ALANI (Zoom bu katmana etki eder, sayfa akışını bozmaz) */}
            <div style={{
                zoom: zoomLevel,
                width: "100%",
                paddingTop: "40px",
                flexGrow: 1
            }}>
                {renderQuestionComponent()}
            </div>

            {/* PAGINATION (Zoom alanından tamamen bağımsızdır, kayma yapmaz ve hep ortalı kalır) */}
            {!loading && (
                <div style={{ width: "100%", marginTop: "30px", paddingBottom: "10px" }}>
                    <Pagination pagination={pagination} />
                </div>
            )}

        </div>
    );
};

export default UserQuestion;